import { Link } from "react-router-dom";
import { motion } from "motion/react";
import { Thumb } from "./Thumb";
import { Icon } from "../../components/Icon";
import { Skeleton } from "../../components/ui";
import { haptic } from "../../telegram/haptics";
import { listItem, pressRow } from "../../motion";
import { isLatinScript, recordDir } from "../../i18n/format";
import { useT } from "../../i18n/strings";
import { termLabel } from "../../i18n/labels";
import type { ArtworkRow as Row } from "../../api/types";
import s from "./artworks.module.css";

export function ArtworkRow({ artwork, onMediaError }: { artwork: Row; onMediaError?: () => void }) {
  const t = useT();
  const latin = isLatinScript(artwork.title);
  const typeLabel = termLabel({
    label_fa: artwork.type_label_fa,
    label_en: artwork.type_label,
  });

  return (
    <motion.div variants={listItem} exit="exit" layout="position">
      <motion.div {...pressRow}>
        <Link
          to={`/artwork/${artwork.id}`}
          className={`${s.row} paper hoverable`}
          onClick={() => haptic.tap()}
        >
          <Thumb
            media={artwork.primary_media}
            layoutId={artwork.primary_media ? `hero-${artwork.primary_media.id}` : undefined}
            onMediaError={onMediaError}
          />

          <div className={s.rowBody}>
            <span
              className={[s.title, latin && s.titleLatin, "bidi"].filter(Boolean).join(" ")}
              dir={recordDir(artwork.title || t.detail.untitled)}
            >
              {artwork.title || t.detail.untitled}
            </span>
            <span className={s.meta}>
              <span
                className={`${s.artist} bidi`}
                dir={recordDir(artwork.artist_name || t.detail.unknownArtist)}
              >
                {artwork.artist_name || t.detail.unknownArtist}
              </span>
              {artwork.year_display && (
                <span className={`mono ${s.year}`}>{artwork.year_display}</span>
              )}
            </span>
          </div>

          <div className={s.rowTail}>
            {typeLabel && <span className={s.typeChip}>{typeLabel}</span>}
            <Icon name="forward" size={16} />
          </div>
        </Link>
      </motion.div>
    </motion.div>
  );
}

export function ArtworkRowSkeleton() {
  return (
    <div className={s.skeletonRow}>
      <Skeleton width={72} height={72} radius="var(--radius-chip)" />
      <div className={s.skeletonBody}>
        <Skeleton height={14} width="55%" radius="4px" />
        <Skeleton height={12} width="35%" radius="4px" />
      </div>
    </div>
  );
}
